import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import { camelCase } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class GeoLocationService {
  constructor() {}

  /**
   * Retrieves GeoLocation information and converts the keys to camelCase.
   * @returns {Promise<any>} A promise that resolves with camel-cased GeoLocation data.
   */
  getGeoInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      $.getJSON('https://json.geoiplookup.io/?callback=?', (data) => {
        const formattedData = this.convertKeysToCamelCase(data);
        resolve(formattedData);
      }).fail(() => {
        console.log('error in getGeoInfo');
        resolve({});
      });
    });
  }

  /**
   * Converts all keys of an object to camelCase recursively.
   * @param {any} source - The source object to be formatted.
   * @returns {any} The new object with camel-cased keys.
   */
  private convertKeysToCamelCase(source: any): any {
    if (Array.isArray(source)) {
      return source.map((element) => this.convertKeysToCamelCase(element));
    } else if (source !== null && typeof source === 'object') {
      return Object.keys(source).reduce((formattedObject, key) => {
        const camelKey = camelCase(key);
        formattedObject[camelKey] = this.convertKeysToCamelCase(source[key]);
        return formattedObject;
      }, {} as any);
    }
    return source;
  }
}
